import { HrefLink } from '@smartbear/swagger-portal-component-library'
import { useTranslation } from 'react-i18next'
import { useHydrated } from 'remix-utils/use-hydrated'

import { useDarkMode } from '~/shared/components/DarkMode/hook.ts'
import componentErrorImageDark from '~/shared/images/provider/product/content/api-error-dark.svg'
import componentErrorImage from '~/shared/images/provider/product/content/api-error.svg'
import appDefaults from '~/shared/shared.defaults.json'

export interface ComponentErrorProps {
  errorId?: string
}

export const ComponentError = ({ errorId }: ComponentErrorProps) => {
  const { t } = useTranslation()
  const { isDark } = useDarkMode()
  const isHydrated = useHydrated()
  return (
    <div className="flex items-center justify-center w-full min-h-full dark:bg-(--sp-color-surface)">
      <div className="relative flex flex-col items-center gap-2 p-4">
        {isHydrated && <img src={isDark() ? componentErrorImageDark : componentErrorImage} alt={t('errors.component.label')} />}
        <h3 className="font-semibold text-body2 text-(--sp-color-text)">
          {t('errors.component.label')}
        </h3>
        <p className="font-semibold text-center text-body3 text-(--sp-color-text)">
          {errorId ? t('errors.report.message', { id: errorId }) : t('errors.report.generalMessage')}
        </p>
        <HrefLink
          className="font-semibold text-body3"
          href={appDefaults.support.supportRequest}
          label={t('errors.report.button.label')}
          size="small"
          isExternal={true}
          target="_blank"
        />
      </div>
    </div>
  )
}